<div
    class="rounded-xl p-3 border border-[#E2E8F0] space-y-2 shadow-sm"
    [ngClass]="isTestimony ? 'bg-[#F8F9FC]' : 'bg-white'">
    <!-- Header: Author info -->
    <div class="flex justify-between items-start">
        <div class="flex space-x-4">
            @if (postCommentSignal().author.photo !== ' ' && postCommentSignal().author.photo) {
                <img
                    class="h-6 w-6 rounded-full object-cover border border-[#e7eaf0]"
                    [alt]="postCommentSignal().author.name"
                    [src]="postCommentSignal().author.photo" />
            } @else {
                <div
                    class="h-6 w-6 rounded-full border border-[#e7eaf0] bg-white text-[#4F66FF] flex items-center justify-center font-bold">
                    {{ postCommentSignal().author.name.charAt(0) | uppercase }}
                </div>
            }
            <p class="text-[#0A0A0A]">
                {{ postCommentSignal().author.name }}
            </p>
        </div>
        <p class="text-[0.75rem] text-[#717182]">{{ timeAgo(postCommentSignal().createdAt) }}</p>
    </div>

    <!-- Testimony -->
    @if (isTestimony) {
        <div class="w-fit truncate whitespace-nowrap text-[0.875rem] text-[#4F66FF]">
            <p>#Testimony</p>
        </div>
    }

    <div class="flex items-center justify-between mt-4">
        <!-- Content -->
        <div class="text-[#0A0A0A] break-words text-[0.875rem]" [innerHTML]="coloredContent"></div>
        @if (isOwnComment()) {
            <div class="relative">
                <div
                    class="sm:block hidden h-4 w-4 cursor-pointer mr-4"
                    [matMenuTriggerFor]="dropdownMenu"
                    (click)="$event.stopPropagation()">
                    <img src="/assets/images/shared/more-options-grey-icon.svg" alt="MoreOptions" />
                </div>

                <mat-menu #dropdownMenu="matMenu">
                    <div class="flex items-center space-x-2 px-4 py-3 cursor-pointer" (click)="editComment()">
                        <img class="w-auto h-4" src="/assets/images/shared/edit-icon.svg" alt="edit icon" />
                        <p class="text-[0.875rem] text-[#0A0A0A]">Edit Comment</p>
                    </div>
                    <div
                        class="flex items-center space-x-2 px-4 py-3 cursor-pointer"
                        (click)="openDeletePostPopup(postCommentSignal().id)">
                        <img class="w-auto h-4" src="/assets/images/shared/delete-red-icon.svg" alt="delete icon" />
                        <p class="text-[0.875rem] text-[#D4183D]">Delete Comment</p>
                    </div>
                </mat-menu>
            </div>
        }
    </div>

    <!-- Bible Verses -->
    @if (this.postCommentSignal().verses && this.postCommentSignal().verses.length) {
        <div class="py-1 px-4 border-l-4 border-[#4F66FF]">
            <p class="text-[#4F66FF] font-medium text-[0.75rem] mb-2">
                {{ getVerseReference() }}
            </p>
            @for (verse of postCommentSignal().verses; track verse.id) {
                <p class="text-[#717182] text-sm">
                    {{ verse.verse }}
                </p>
            }
        </div>
    }

    <!-- Image -->
    @if (postCommentSignal().attachment) {
        <img alt="Image" class="rounded-lg block max-w-full h-auto" [src]="postCommentSignal().attachment" />
    }

    <!-- Actions / Counts -->
    <div class="flex justify-between items-start py-2">
        <div class="flex space-x-6 text-[#717182] text-[0.875rem]">
            <div class="flex items-center space-x-1 cursor-pointer" (click)="toggleLike(postCommentSignal())">
                <img
                    alt="Like"
                    class="h-4 w-4"
                    [src]="
                        postCommentSignal().liked
                            ? '/assets/images/post/like-red-icon.svg'
                            : '/assets/images/post/like-icon.svg'
                    " />
                <span>{{ postCommentSignal().likeCount }}</span>
            </div>

            @if (!isTestimony) {
                <p class="text-xs text-[#717182] cursor-pointer" (click)="toggleReply()">
                    {{ isReplying() ? 'Cancel' : 'Reply' }}
                </p>
            }
        </div>
    </div>

    <!-- Reply -->
    @if (postCommentSignal().responses?.length) {
        <div class="py-1 px-4 border-l border-[#E2E8F0] space-y-4">
            @if ((postCommentSignal().responses?.length ?? 0) > visibleRepliesCount()) {
                <p class="text-xs text-[#4F66FF] cursor-pointer" (click)="loadMoreReplies()">Load more replies</p>
            }
            @for (reply of visibleReplies; track reply.id) {
                <div class="flex flex-col space-y-1">
                    <!-- Author info -->
                    <div class="flex items-center space-x-2">
                        @if (reply.author.photo !== ' ' && reply.author.photo) {
                            <img
                                class="h-6 w-6 rounded-full object-cover border border-[#e7eaf0]"
                                [alt]="reply.author.name"
                                [src]="reply.author.photo" />
                        } @else {
                            <div
                                class="h-6 w-6 rounded-full border border-[#e7eaf0] bg-white text-[#4F66FF] flex items-center justify-center font-bold">
                                {{ reply.author.name.charAt(0) | uppercase }}
                            </div>
                        }
                        <p class="text-[#0A0A0A]">
                            {{ reply.author.name }}
                        </p>
                        <p class="text-[0.625rem] text-[#717182]">{{ timeAgo(reply.createdAt) }}</p>
                    </div>

                    <div class="flex items-center justify-between mt-4">
                        <!-- Content -->
                        <div class="text-[#0A0A0A] break-words text-[0.875rem]" [innerHTML]="reply.content"></div>
                        @if (reply.author.id === getUserProfileDetails?.id) {
                            <div class="relative">
                                <div
                                    class="sm:block hidden h-4 w-4 cursor-pointer"
                                    [matMenuTriggerFor]="dropdownMenu"
                                    (click)="$event.stopPropagation()">
                                    <img src="/assets/images/shared/more-options-grey-icon.svg" alt="MoreOptions" />
                                </div>

                                <mat-menu #dropdownMenu="matMenu">
                                    <div
                                        class="flex items-center space-x-2 px-4 py-3 cursor-pointer"
                                        (click)="editReply(reply.id)">
                                        <img
                                            class="w-auto h-4"
                                            src="/assets/images/shared/edit-icon.svg"
                                            alt="edit icon" />
                                        <p class="text-[0.875rem] text-[#0A0A0A]">Edit Reply</p>
                                    </div>
                                    <div
                                        class="flex items-center space-x-2 px-4 py-3 cursor-pointer"
                                        (click)="openDeletePostPopup(reply.id, true)">
                                        <img
                                            class="w-auto h-4"
                                            src="/assets/images/shared/delete-red-icon.svg"
                                            alt="delete icon" />
                                        <p class="text-[0.875rem] text-[#D4183D]">Delete Reply</p>
                                    </div>
                                </mat-menu>
                            </div>
                        }
                    </div>

                    <!-- Like -->
                    <div
                        class="flex items-center space-x-1 cursor-pointer text-[#717182] text-[0.875rem]"
                        (click)="toggleReplyLike(reply)">
                        <img
                            alt="Like"
                            class="h-4 w-4"
                            [src]="
                                reply.liked
                                    ? '/assets/images/post/like-red-icon.svg'
                                    : '/assets/images/post/like-icon.svg'
                            " />
                        <span>{{ reply.likeCount }}</span>
                    </div>
                </div>
            }
        </div>
    }

    @if (isReplying() || isEditingReply()) {
        <form [formGroup]="replyForm" (ngSubmit)="submitReply()">
            <div class="mt-2 flex gap-4">
                <input
                    type="text"
                    placeholder="Write a reply..."
                    class="w-full px-3 py-2 border border-[#E7EAF0] rounded-2xl text-sm focus:outline-none"
                    formControlName="content" />

                <!-- Submit -->
                <button type="submit" class="border-button p-3 rounded-lg flex-shrink-0" [disabled]="replyForm.invalid">
                    <img src="/assets/images/shared/up-arrow-icon.png" alt="Up" class="h-5 w-auto rotate-90" />
                </button>
            </div>
        </form>
    }
</div>
